<div app-sortable id="pivotsID" class="p-1 isSortableContainer app-sortable-container" (sendSortableStop)="receiveSortableStop($event)">
  <div *ngFor="let layer of layers" class="isSortableElement app-cursor-grab">
    <app-links-item *ngIf="layer.drillable" [bottomMargin]="lastVisibleLayerRank != layer.rank" [color]="color" [icon]="icon" [labels]="layer.layerLabel" [uid]="layer.uid"></app-links-item>
  </div>
</div>